import React, { useEffect, useState } from 'react';
import { Check, AlertTriangle, X, Info } from 'lucide-react';

const C = {
  bg: '#FDFBF7', text: '#1A1A18', muted: '#9A9590',
  green: '#5A8C6A', accent: '#C67A5C', card: '#FFFFFF',
};

const ICON_MAP = {
  success: { Icon: Check, bg: `${C.green}15`, color: C.green },
  error: { Icon: AlertTriangle, bg: `${C.accent}15`, color: C.accent },
  info: { Icon: Info, bg: '#4A90D915', color: '#4A90D9' },
};

let _showNotification = () => {};

export function showNuriNotification(message, type = 'success', duration = 3000) {
  _showNotification({ message, type, duration });
}

export function NuriNotificationProvider({ children }) {
  const [notification, setNotification] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    _showNotification = ({ message, type, duration }) => {
      setNotification({ message, type, duration });
      setVisible(true);
      setTimeout(() => setVisible(false), duration);
      setTimeout(() => setNotification(null), duration + 300);
    };
    return () => { _showNotification = () => {}; };
  }, []);

  if (!notification) return <>{children}</>;

  const config = ICON_MAP[notification.type] || ICON_MAP.success;
  const { Icon } = config;

  return (
    <>
      {children}
      <div
        data-testid="nuri-notification"
        style={{
          position: 'fixed',
          top: 0, left: 0, right: 0, bottom: 0,
          zIndex: 9999,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          pointerEvents: visible ? 'auto' : 'none',
        }}
        onClick={() => { setVisible(false); setTimeout(() => setNotification(null), 300); }}
      >
        {/* Backdrop */}
        <div style={{
          position: 'absolute', inset: 0,
          background: 'rgba(0,0,0,0.15)',
          opacity: visible ? 1 : 0,
          transition: 'opacity 0.2s ease',
        }} />

        {/* Notification card */}
        <div
          onClick={e => e.stopPropagation()}
          style={{
            position: 'relative',
            background: C.card,
            borderRadius: 20,
            padding: '24px 28px',
            maxWidth: 320,
            width: '85%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 12,
            boxShadow: '0 20px 60px rgba(0,0,0,0.12), 0 4px 16px rgba(0,0,0,0.06)',
            border: '1px solid rgba(232,227,219,0.6)',
            transform: visible ? 'scale(1) translateY(0)' : 'scale(0.9) translateY(10px)',
            opacity: visible ? 1 : 0,
            transition: 'all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
          }}
        >
          {/* Icon */}
          <div style={{
            width: 48, height: 48, borderRadius: 14,
            background: config.bg,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>
            <Icon style={{ width: 24, height: 24, color: config.color }} />
          </div>

          {/* Message */}
          <p style={{
            fontSize: 15, fontWeight: 500, color: C.text,
            fontFamily: 'var(--font-sans)', textAlign: 'center',
            lineHeight: 1.4, margin: 0,
          }}>
            {notification.message}
          </p>

          {/* Dismiss */}
          <button
            data-testid="nuri-notification-close"
            onClick={() => { setVisible(false); setTimeout(() => setNotification(null), 300); }}
            style={{
              marginTop: 4, padding: '8px 24px', borderRadius: 12,
              border: 'none', background: config.bg, cursor: 'pointer',
              fontSize: 13, fontWeight: 600, color: config.color,
              fontFamily: 'var(--font-sans)',
            }}
          >
            OK
          </button>
        </div>
      </div>
    </>
  );
}
